import React, { useEffect, useRef } from 'react';

// Components
import { QuoteCoverageGroup } from '../../../../../../../../../types/Quotes';
import DropdownButton from '../../shared/DropdownButton';
import OfferCoverage from '../../shared/OfferCoverage';
import {
  Box,
  HStack,
  Icon,
  IconName,
  Text,
  VStack,
} from '@wegroup/design-system';

interface Props {
  subOptions: QuoteCoverageGroup[];
  shouldScroll?: boolean;
  isOpen: boolean;
  setIsOpen: (arg0: boolean) => void;
}

const ComparisonCollapsableOption: React.FC<React.PropsWithChildren<Props>> = ({
  subOptions,
  shouldScroll,
  isOpen,
  children,
  setIsOpen,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && contentRef.current && shouldScroll)
      contentRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [isOpen]);

  return (
    <>
      <Box pt="2" ref={contentRef}>
        <HStack
          justify="space-between"
          onClick={() => setIsOpen(!isOpen)}
          px="4"
          py="6"
          borderRadius="md"
          bg={isOpen ? 'primary.500' : 'primary.50'}
          cursor="pointer"
        >
          <Text textStyle="largeBodyBold" color={isOpen ? 'white' : 'black'}>
            {children}
          </Text>
          <DropdownButton isOpen={isOpen} />
        </HStack>
        {isOpen && (
          <VStack spacing="4" mx="4" my="6" align="stretch">
            {subOptions.map(({ icon_key, name, rating, key, description }) => (
              <OfferCoverage
                key={key}
                Icon={<Icon name={icon_key as IconName} color="gray.300" />}
                coverage={rating}
                isActive={true}
                description={description}
              >
                {name}
              </OfferCoverage>
            ))}
          </VStack>
        )}
      </Box>
    </>
  );
};

export default ComparisonCollapsableOption;
